import type { TTypeIdentity } from '@/domain/Book/contracts/TTypeIdentity'

export const toIds = (items: TTypeIdentity[]) => {
  const ids = items.map((item) => item?.id).filter((item) => item !== undefined)

  return Array.from(new Set(ids)) // ensure only distinct elements are present
}
